module.exports = __webpack_public_path__ + "static/media/hqx_1er.1d4bcf98.jpg";